import './FooterContainer.css'
import petImage from '../../../assets/footer/cat_bg-removebg-preview.png'
import bigAnimal from '../../../assets/footer/grand-footer.png'

import FooterInfo from '../FooterInfo/FooterInfo'
import FooterLegend from '../FooterLegend/FooterLegend'

export default function FooterContainer({isGrand = false}) {
   return (
      <footer className={`footer ${isGrand ? "footer-grand" : ""}`}>
         < FooterLegend />
         < FooterInfo />
         < img className='footer-bkgImage' src={isGrand ? bigAnimal : petImage} alt={isGrand ? "foto de un caballo" : "foto de gato"} />
      </footer>
   )
}
